import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { useListPayStations } from 'src/features/payment/api/useListPayStations';
import { paymentsMessages } from 'src/features/payment/utils/messages';
import { FISCAL_DEVICE_TRANSLATIONS_MAP } from 'src/features/systems/utils/constants';
import { SystemComponentFormSchemaValues } from 'src/features/systems/utils/formSchema';
import { systemsMessages } from 'src/features/systems/utils/messages';
import { FISCAL_DEVICE_TYPE } from 'src/features/systems/utils/types';
import { useParking } from 'src/providers/ParkingProvider';
import InputFormField from 'src/registry/components/forms/InputFormField';
import SelectFormField from 'src/registry/components/forms/SelectFormField';

type FiscalDeviceFormFieldsProps = {
    form: UseFormReturn<SystemComponentFormSchemaValues>;
};

const FiscalDeviceFormFields = ({ form }: FiscalDeviceFormFieldsProps) => {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const { data: payStationsData } = useListPayStations({ parkingId });

    const payStationOptions = payStationsData?.results?.map((ps) => ps.id) ?? [];
    const payStationTranslationMap = Object.fromEntries(
        payStationsData?.results?.map((ps) => [ps.id, { id: ps.id, defaultMessage: ps.name }]) ?? [],
    );

    return (
        <>
            <SelectFormField<SystemComponentFormSchemaValues>
                options={payStationOptions}
                form={form}
                name="pay_station"
                label={formatMessage(paymentsMessages.payStation)}
                optionTranslationMap={payStationTranslationMap}
                required={false}
            />
            <SelectFormField<SystemComponentFormSchemaValues>
                options={Object.values(FISCAL_DEVICE_TYPE)}
                form={form}
                name="data.type"
                label={formatMessage(systemsMessages.type)}
                optionTranslationMap={FISCAL_DEVICE_TRANSLATIONS_MAP}
            />
            <InputFormField<SystemComponentFormSchemaValues>
                form={form}
                name="data.api_url"
                label={formatMessage(systemsMessages.apiUrl)}
            />
            <InputFormField<SystemComponentFormSchemaValues>
                form={form}
                name="data.api_key"
                label={formatMessage(systemsMessages.apiKey)}
            />
        </>
    );
};

export default FiscalDeviceFormFields;
